module.exports = __webpack_public_path__ + "img/markdown-preview.ecdaabbc.png";